import { getCapabilities } from '@mc/user-info'

/**
 * Fetches user capabilities and transforms them to analytics traits with uc_ prefix
 * Fails silently and returns empty object if capabilities are unavailable
 * @returns Object with capabilities formatted as uc_[capability_key]: value, or empty object on error
 */
const getCapabilitiesTraits = async (): Promise<Record<string, string>> => {
  try {
    const capabilitiesResponse = await getCapabilities()

    // Defensive: check if response and array exist
    if (
      !capabilitiesResponse?.userCapabilities ||
      !Array.isArray(capabilitiesResponse.userCapabilities)
    ) {
      return {}
    }

    // Transform capabilities to uc_* format
    return capabilitiesResponse.userCapabilities.reduce(
      (acc, cap) => {
        // Defensive: ensure cap has required properties
        if (cap?.key && cap?.value !== undefined) {
          acc[`uc_${cap.key}`] = cap.value
        }
        return acc
      },
      {} as Record<string, string>,
    )
  } catch (error) {
    // Fail silently - capabilities are optional for analytics
    // Don't break the identify flow
    return {}
  }
}

export default getCapabilitiesTraits
